define(function(require) {
	const emptyTemplate = require('civicsViews/favoriteContacts/templates/t_lov_empty_view.hbs');
	return Marionette.ItemView.extend({
    template: emptyTemplate,
    initialize: function(options) {
      this.message = options.message;
    },
    templateHelpers: function () {
      return {
        message: this.options.message
      };
    },
	});

});
